import { render } from "./MovimentosFechados.vue?vue&type=template&id=f6bebfbc&scoped=true"
import script from "./MovimentosFechados.vue?vue&type=script&lang=js"
export * from "./MovimentosFechados.vue?vue&type=script&lang=js"

import "./MovimentosFechados.vue?vue&type=style&index=0&id=f6bebfbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6bebfbc"]])

export default __exports__